import items from "@/api/items";

export default {
  state: {
  },
  mutations: {
  },
  actions: {
    async showItems(context, { season_id, item_id }) {
      try {
        let params = {
          account_id: await context.dispatch("showAccountID"),
          management_id: await context.dispatch("showManagementID"),
        };
        if (season_id) {
          params.season_id = season_id;
        }
        if (item_id) {
          params.item_id = item_id;
        }
        let res = await items.show(params);
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async insertItems(context, params) {
      try {
        params.account_id = await context.dispatch("showAccountID");
        await items.insert(params);
      } catch (error) {
        console.log(error);
      }
    },
    async updateItems(context, params) {
      try {
        params.account_id = await context.dispatch("showAccountID");
        await items.update(params);
      } catch (error) {
        console.log(error);
      }
    },
    async updateOrderItems(context, params) {
      try {
        await items.updateOrder(params);
      } catch (error) {
        console.log(error);
      }
    },
    async deleteItems(context, id) {
      try {
        let params = {
          account_id: await context.dispatch("showAccountID"),
        };
        if (id) {
          params.item_id = id;
        }
        await items.del(params);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
